import * as Yup from "yup";

/**
 * Validation class for Dummy User form
 * Contains validation schema for the dummy user add/edit fields
 */
class DummyUserValidationClass {
  /**
   * Dummy User validation schema
   * @param {function} t - Translation function
   * @returns {Yup.ObjectSchema} Validation schema for the dummy user form
   */
  static dummyUserValidation(t = (key) => key) {
    return Yup.object().shape({
      first_name: Yup.string()
        .trim()
        .required(t("admin.dummy_user_validation_first_name_required"))
        .max(100, t("admin.dummy_user_validation_first_name_max_length")),
      last_name: Yup.string()
        .trim()
        .required(t("admin.dummy_user_validation_last_name_required"))
        .max(100, t("admin.dummy_user_validation_last_name_max_length")),
      email: Yup.string()
        .trim()
        .required(t("admin.dummy_user_validation_email_required"))
        .email(t("admin.dummy_user_validation_email_invalid"))
        .max(150, t("admin.dummy_user_validation_email_max_length")),
      house_number: Yup.string()
        .trim()
        .required(t("admin.dummy_user_validation_house_number_required"))
        .max(100, t("admin.dummy_user_validation_house_number_max_length")),
      street: Yup.string()
        .trim()
        .required(t("admin.dummy_user_validation_street_required"))
        .max(100, t("admin.dummy_user_validation_street_max_length")),
      city: Yup.string()
        .trim()
        .required(t("admin.dummy_user_validation_city_required"))
        .max(100, t("admin.dummy_user_validation_city_max_length")),
      country: Yup.string()
        .trim()
        .required(t("admin.dummy_user_validation_country_required"))
        .max(100, t("admin.dummy_user_validation_country_max_length")),
      zip_code: Yup.string()
        .trim()
        .required(t("admin.dummy_user_validation_zip_code_required"))
        .max(20, t("admin.dummy_user_validation_zip_code_max_length")),
      latitude: Yup.number()
        .typeError(t("admin.dummy_user_validation_latitude_required"))
        .required(t("admin.dummy_user_validation_latitude_required"))
        .min(-90, t("admin.dummy_user_validation_latitude_invalid"))
        .max(90, t("admin.dummy_user_validation_latitude_invalid")),
      longitude: Yup.number()
        .typeError(t("admin.dummy_user_validation_longitude_required"))
        .required(t("admin.dummy_user_validation_longitude_required"))
        .min(-180, t("admin.dummy_user_validation_longitude_invalid"))
        .max(180, t("admin.dummy_user_validation_longitude_invalid")),
    });
  }
}

export default DummyUserValidationClass;
